import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App';
import '../styles/vendors.css';
import '../styles/styles.css';
import '../styles/tailwind.css';

// MUI theme — override Modal default props to avoid aria-hidden focus warning
const theme = createTheme({
    components: {
        MuiModal: {
            defaultProps: {
                closeAfterTransition: false,
            },
        },
    },
});

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
